// Components
import { RootState } from '../index';

const getSessionsData = (state: RootState) => state.shootingDataSlice.sessions;

const getScenariosData = (state: RootState) => state.shootingDataSlice.scenarios;

const getTransactionsData = (state: RootState) => state.shootingDataSlice.transactions;

const getRepetitionsData = (state: RootState) => state.shootingDataSlice.repetitions;

const getWeaponPresentation = (state: RootState) => state.shootingDataSlice.weapon_presentation;

const getStabilityPresentation = (state: RootState) => state.shootingDataSlice.stability_presentation;

export {
  getSessionsData,
  getScenariosData,
  getTransactionsData,
  getRepetitionsData,
  getWeaponPresentation,
  getStabilityPresentation
};
